import Constants from 'config/Constants';
import HelperFunctions from 'pages/global/HelperFunctions';
import { useGetLabelFolders } from 'pages/labels/hooks/useGetLabelFolders';
import { Badge, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const defaultContent = {
    labelFolder: '',
    options: [],
};

export function LabelBlock({ block }) {
    const latestContent = HelperFunctions.tryParseJSON(block.latestContent, defaultContent);

    return (
        <div className="p-4">
            <LabelBlockContent block={block} latestContent={latestContent} />
        </div>
    );
}

function LabelBlockContent({ block, latestContent }) {
    const { t } = useTranslation('documents');
    const { labelFolder } = latestContent;
    const folders = useGetLabelFolders();

    // Filter folders
    const allowedTypes = Object.keys(Constants.labelFolderEntities).filter((_entity) => {
        return Constants.labelFolderEntities[_entity].includes('labelBlock');
    });

    const availableFolders = folders.filter((_folder) =>
        _folder.contentTypes.some((_type) => allowedTypes.includes(_type)),
    );

    const folderOption = availableFolders.find((folder) => folder.id === labelFolder);

    return (
        <div className="pt-3">
            <Form.Group as={Row} className="mb-0">
                <Form.Label column sm={4} htmlFor="labelFolder">
                    {t('document.navbar.main.editor.left.blocks.types.labelBlock.map')}
                </Form.Label>
                <Col sm={8}>
                    <input
                        type="text"
                        readOnly
                        className="form-control-plaintext"
                        id="labelFolder"
                        value={folderOption?.name ?? '-'}
                    />
                </Col>
            </Form.Group>

            {labelFolder !== '' && (
                <Form.Group as={Row}>
                    <Form.Label column sm={4} htmlFor="options">
                        {t('document.navbar.main.editor.left.blocks.types.labelBlock.value')}
                    </Form.Label>
                    <Col sm={8}>
                        <div style={{ paddingTop: '0.6rem' }}>
                            <LabelBlockOptions block={block} latestContent={latestContent} />
                        </div>
                    </Col>
                </Form.Group>
            )}
        </div>
    );
}

function LabelBlockOptions({ block, latestContent }) {
    const multiple = block.properties.multiple === true;
    const { options = [], changes = {} } = latestContent;

    if (options.length === 0) {
        return <>-</>;
    }

    if (!multiple && options.length === 2 && Object.keys(changes).length === 2) {
        return <SingleItemChanges latestContent={latestContent} />;
    }

    return (
        <>
            {options.map((_option, index) => {
                return (
                    <Badge
                        className="mr-1 label-block-text-color"
                        variant="primary"
                        key={`block-${block.key}-option-${index}`}
                    >
                        {_option.label}
                    </Badge>
                );
            })}
        </>
    );
}

function SingleItemChanges({ latestContent }) {
    const { options = [], changes = {} } = latestContent;

    const optionOne = options[0];
    const optionTwo = options[1];

    let oldLabel = optionOne.label;
    let newLabel = optionTwo.label;

    // optionOne is added, so reverse the labels
    if (changes[optionOne.id] === 'a') {
        oldLabel = optionTwo.label;
        newLabel = optionOne.label;
    }

    return (
        <Badge variant="warning">
            <del>{oldLabel}</del>
            <ins>{newLabel}</ins>
        </Badge>
    );
}
